const eventStructureQueryKeys = {
  all: ["event-structure"] as const,
  get: ({
    id,
    eventId,
    structureId,
  }: {
    id?: string;
    eventId?: string;
    structureId?: string;
  }) =>
    [
      ...eventStructureQueryKeys.all,
      ...(id ? ["id", id] : []),
      ...(eventId ? ["event", eventId] : []),
      ...(structureId ? ["structure", structureId] : []),
    ] as const,
};

export default eventStructureQueryKeys;
